import { HSLColor } from '@yola/yola-palette-generator';
import getBlockSurface from '../../website-design/helpers/get-block-surface';
import getSurfaceBackground from '../../website-design/helpers/get-surface-background';
import parseHslColorString from '../../website-design/helpers/parse-hsl-color-string';
import isLightColorType from '../../website-design/helpers/is-light-color-type';
import getCompiledCurrentPalette from '../../website-design/helpers/get-compiled-current-palette';

const COLUMN_WITH_SURFACE_SELECTOR = 'ws-column[surface]';

const getHighlighterColor = (element, options) => {
  if (!options.hovered) {
    return 'default';
  }

  const columnWithSurface = element.closest(COLUMN_WITH_SURFACE_SELECTOR);

  const surface = columnWithSurface
    ? columnWithSurface.getAttribute('surface')
    : getBlockSurface(element);

  if (!surface) {
    return 'default';
  }

  const { variables: paletteVariables } = getCompiledCurrentPalette();
  const background = getSurfaceBackground(surface, paletteVariables);
  const backgroundHSL = new HSLColor(...Object.values(parseHslColorString(background)));

  return isLightColorType(backgroundHSL) ? 'dark' : 'light';
};

export default getHighlighterColor;
